import { objectURLToFile } from '../../../../utils/generalHelpers';
import { uploadFileThunk } from '../../../../store/general/thunks';
import { useDispatch, useSelector } from '../../../../store/store';
import MotionWrapper from '../../../../containers/MotionWrapper';
import { kycThunk } from '../../../../store/signUp/thunks';
import Spinner from '../../../../components/Spinner';
import Button from '../../../../components/Button';
import styles from './style.module.scss';
import { useEffect } from 'react';
import {
    KycAnalyzeIllustration,
    KycAnalyzeFailedIllustration,
} from '../../../../assets/illustrations';
import {
    setIDPhoto,
    setKYCStatus,
    setSignUpStep,
    setPersonalPhoto,
    setPhoneNumberDisable,
} from '../../../../store/signUp/slice';
import {
    selectUserId,
    selectIDPhoto,
    selectKYC_Status,
    selectPersonalPhoto,
} from '../../../../store/signUp/selectors';

function KYC() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const IDPhoto = useSelector(selectIDPhoto);
    const status = useSelector(selectKYC_Status);
    const personalPhoto = useSelector(selectPersonalPhoto);

    useEffect(() => {
        uploadAndKYC();

        return () => {
            dispatch(setKYCStatus('Pending'));
        }
    }, []);

    const uploadAndKYC = async () => {
        if (!personalPhoto || !IDPhoto) return;
        const PIF = await objectURLToFile(personalPhoto, 'face.png', 'image/png');
        const IDF = await objectURLToFile(IDPhoto, 'id.png', 'image/png');
        const PIF_eTag = (await dispatch(uploadFileThunk({ fileName: `${userId}/face.png`, file: PIF }))).payload;
        const IDF_eTag = (await dispatch(uploadFileThunk({ fileName: `${userId}/id.png`, file: IDF }))).payload;

        dispatch(kycThunk({
            e_tags: [PIF_eTag, IDF_eTag]
        }));
    };

    const startOver = () => {
        dispatch(setIDPhoto(null));
        dispatch(setPersonalPhoto(null));
        dispatch(setPhoneNumberDisable(true));
        dispatch(setSignUpStep('personalInfo'));
    };

    return (
        <MotionWrapper className={styles.container}>
            {status === 'Pending' && <>
                <KycAnalyzeIllustration />
                <span className={styles.title}>
                    Analyzing KYC information
                </span>
                <span className={styles.text}>
                    We are analyzing your KYC information. Please wait a moment.
                </span>
                <Spinner />
            </>}

            {status === 'Reject' && <>
                <KycAnalyzeFailedIllustration />
                <span className={styles.title} data-is-error="true">
                    KYC was unsuccessful!
                </span>
                <span className={styles.text}>
                    Please ensure the accuracy of your information.
                </span>
                <div className={styles.actions}>
                    <Button
                        text='Try again'
                        type='Outline-Dark'
                        onClick={startOver}
                        className={styles.actions_btn}
                    />
                    <Button
                        type='Primary'
                        text='Verify later'
                        className={styles.actions_btn}
                        onClick={() => dispatch(setSignUpStep('workExperience'))}
                    />
                </div>
            </>}
        </MotionWrapper>
    )
};

export default KYC;
